import { Instagram } from "lucide-react";
import { Logo } from "./Logo";
import { scrollToSection } from "@/lib/lenis";

const LINKS = [
  { id: "story", label: "Story" },
  { id: "wisdom", label: "Wisdom" },
  { id: "impact", label: "Impact" },
  { id: "farm", label: "Farm" },
  { id: "products", label: "Products" },
  { id: "leadership", label: "Leadership" },
  { id: "visit", label: "Visit" },
  { id: "contact", label: "Contact" },
];

const INSTAGRAM_URL = "https://www.instagram.com/adveshta.cow";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-ink text-cream overflow-hidden">
      <div className="max-w-[1440px] mx-auto px-6 md:px-12 pt-20">
        <div
          aria-hidden="true"
          className="select-none font-serif font-semibold text-[13.5vw] leading-[0.85] whitespace-nowrap text-outline-cream"
        >
          ADVESHTA
        </div>

        <div className="mt-16 grid md:grid-cols-3 gap-12 pb-16">
          <div>
            <Logo tone="light" />
            <p data-testid="footer-since" className="mt-5 inline-flex items-center rounded-full border border-gold/40 bg-gold/10 px-3.5 py-1.5 font-mono text-[9px] uppercase tracking-[0.25em] text-gold">
              Working since 2022
            </p>
            <p className="mt-5 text-sm leading-relaxed text-cream/60 max-w-xs">
              Organic dairy rooted in rural Gujarat — pure milk, fair trade, village first.
              Adveshta Projects Private Limited has been working with village dairy farmers since
              2022.
            </p>
            <p className="mt-4 font-gujarati text-sm text-gold">શુદ્ધ. તાજું. ગામડાંનું.</p>
            <a
              data-testid="footer-instagram-link"
              href={INSTAGRAM_URL}
              target="_blank"
              rel="noreferrer"
              className="mt-6 inline-flex items-center gap-3 rounded-full border border-cream/20 px-5 py-2.5 font-mono text-[10px] uppercase tracking-[0.22em] text-cream/80 hover:border-gold hover:text-gold transition-colors duration-300"
            >
              <Instagram className="h-4 w-4" /> @adveshta.cow
            </a>
            <p data-testid="footer-delivery-note" className="mt-6 text-xs leading-relaxed text-cream/50">
              Home delivery in Vyara city &amp; nearby areas · Farm visits on Saturdays &amp;
              Sundays (advance booking)
            </p>
          </div>

          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-gold">Contact</p>
            <a
              data-testid="footer-phone-link"
              href="tel:+918141261616"
              className="mt-5 block font-serif text-2xl text-cream hover:text-gold transition-colors duration-300"
            >
              +91 81412 61616
            </a>
            <p className="mt-1 text-xs text-cream/50">Call or WhatsApp · orders, delivery & farm visits</p>
            <p className="mt-6 font-mono text-[10px] uppercase tracking-[0.3em] text-gold">Addresses</p>
            <address className="mt-5 not-italic text-sm leading-relaxed text-cream/60">
              <span className="block text-cream/85">Adveshta Projects Private Limited</span>
              JM/R-201, Second Floor, Wing-R (Janaadhar Mangla), Block No-45, Shram Marg, Zone-4
              Gift City, Gandhinagar - 382355
            </address>
            <address className="mt-4 not-italic text-sm leading-relaxed text-cream/60">
              <span className="block text-cream/85">Adveshta Milk · Project Site</span>
              Khushalpura, Gamit Faliya, Next to Shiv Temple, Vyara - 394650
            </address>
          </div>

          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-gold">Explore</p>
            <div className="mt-5 grid grid-cols-2 gap-x-6 gap-y-3">
              {LINKS.map((l) => (
                <button
                  key={l.id}
                  data-testid={`footer-link-${l.id}`}
                  onClick={() => scrollToSection(l.id)}
                  className="justify-self-start text-sm text-cream/60 hover:text-gold transition-colors duration-300"
                >
                  {l.label}
                </button>
              ))}
            </div>
          </div>
        </div>

        <div className="border-t border-cream/10 py-7 flex flex-col md:flex-row gap-3 items-start md:items-center justify-between font-mono text-[10px] uppercase tracking-[0.22em] text-cream/45">
          <p data-testid="footer-copyright">© {year} Adveshta Projects Private Limited · Since 2022</p>
          <p data-testid="footer-leadership">
            CEO · Alkaben Vinodbhai Patel &nbsp;|&nbsp; COO · Nachiket Vinodbhai Patel
          </p>
        </div>
      </div>
    </footer>
  );
}
